module.exports = __webpack_public_path__ + "img/crown_2.09288ead.png";